module.exports = __webpack_public_path__ + "img/1449201972.0126ee0e.jpg";